import { DataLevel, ResultAPI } from '@/lib/model';

export const getMapSettings = (level: DataLevel) => {
  switch (level) {
    case DataLevel.COMUNE:
      return {
        layerPropId: 'PRO_COM',
        //sourceLayer: '20230213_Comuni_LazioLombardia',
        // sourceLayer: '25_Comuni_5',
        sourceLayer: '20240309_Comuni_Abruzzo',
        zoom: 6.8,

      };

    case DataLevel.PROVINCIA:
      return {
        layerPropId: 'COD_PROV',
        // sourceLayer: '20230213_Province_LazioLombardia',
        sourceLayer: '20240309_Province_Abruzzo',
        zoom: 6.8,
      };

    case DataLevel.REGIONE:
    case DataLevel.MAIN:
    default:
      return {
        layerPropId: 'COD_REG',
        // sourceLayer: '20230213_Regioni_LazioLombardia',
        // sourceLayer: '25_Circo_Camera_2020',
        sourceLayer: '20240309_Regioni_Abruzzo',
        zoom: 6.8,
      };
  }
};

export const getLevelSettings = (
  level: DataLevel
): {
  directory: string;
  variable: keyof ResultAPI['int'];
} => {
  switch (level) {
    case DataLevel.COMUNE:
      return {
        directory: 'comuni',
        variable: 'cod_com', // will be anyway overriden with PRO_COM
      };

    case DataLevel.PROVINCIA:
      return {
        directory: 'collegi',
        variable: 'cod_prov',
      };

    case DataLevel.REGIONE:
      return {
        directory: 'regioni',
        variable: 'cod_reg',
      };

    case DataLevel.MAIN:
    default:
      return {
        directory: '', // set in different place
        variable: 'cod_reg',
      };
  }
};
